import script from "./DayParamsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayParamsComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__